import * as React from 'react'

import classNames from 'classnames/bind'

import { observer } from 'mobx-react'

import type { RadioOptionType } from 'modules/core/components/Inputs/RadioGroup/types'

import labeledStyles from './styles/labeled.module.scss'
import menuToggleStyles from './styles/menuToggle.module.scss'
import toggleStyles from './styles/toggle.module.scss'

const THEMES = {
  labeled: labeledStyles,
  toggle: toggleStyles,
  menuToggle: menuToggleStyles,
}

function Radio(props: RadioOptionType) {
  const themeStyles = THEMES[props.theme]
  const cxTheme = classNames.bind(themeStyles)

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.field.set(event.target.value)
  }

  const labelStyles = (checked: boolean) => {
    const { color } = props

    if (checked && !!color) {
      return {
        backgroundColor: color,
        borderColor: color,
      }
    }

    return {}
  }

  const { option, name, field, invisible, readonly } = props
  const { value, label } = option
  const checked = value === field.value

  return (
    <label
      className={cxTheme('item', {
        readonly,
        checked,
      })}
      style={labelStyles(checked)}
    >
      {!readonly && (
        <input
          className={cxTheme('input', {
            invisible,
          })}
          name={name}
          value={value}
          type="radio"
          checked={checked}
          onChange={onChange}
        />
      )}
      <span className={themeStyles.label}>{label}</span>
    </label>
  )
}

export default observer(Radio)
